import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";

/* plugins */
Alpine.plugin(collapse);

/* start your engines */
window.Alpine = Alpine;
Alpine.start();